<script setup lang="ts">
import dayjs from "dayjs";
import type { License } from "~/modules/license/models/License.interface";

const { t } = useI18n();

defineProps<{
  license: License;
}>();
</script>

<template>
  <div class="font-semibold">
    {{ t("license.characteristics.title") }}
  </div>
  <p class="mt-0.5 mb-2 text-[#667085] flex flex-wrap items-center">
    <span>{{ t("license.characteristics.id") }}&nbsp;</span>
    <span class="flex items-center">
      <span class="mr-7">{{ license.id }}</span>
      <lxc-copy-to-clipboard
        :title="t('button.copiedTitle')"
        :info-to-copy="license.id"
      />
    </span>
  </p>
  <div>
    <div class="text-[#667085] mb-2">
      {{ t("license.characteristics.date.validated") }}
    </div>
    <div class="mb-4 flex items-center font-medium">
      <i-lxc-calendar height="1.72rem" width="1.72rem" class="mr-4" />
      {{
        t("license.characteristics.date.validatedOn", {
          date: dayjs(license.updatedAt).format("LL"),
        })
      }}
    </div>
  </div>
  <div class="text-[#667085] mb-2">
    {{ t("license.characteristics.date.end") }}
  </div>
  <div class="mb-4 flex items-center font-medium">
    <i-lxc-calendar height="1.72rem" width="1.72rem" class="mr-4" />
    {{ dayjs(license.expiresAt).format("LL") }}
  </div>
</template>
